import type { SearchResult } from "@mirage/service-dbx-api";

export const ASSISTANT_FILE_UPLOAD_CONNECTOR_ID = "assistant_file_upload";
export function isAssistantFileUpload(result: SearchResult): boolean {
  return (
    result.connectorInfo?.connectorName === ASSISTANT_FILE_UPLOAD_CONNECTOR_ID
  );
}
